import { render, staticRenderFns } from "./Globals.vue?vue&type=template&id=3ded9e6c&scoped=true&"
import script from "./Globals.vue?vue&type=script&lang=js&"
export * from "./Globals.vue?vue&type=script&lang=js&"
import style0 from "./Globals.vue?vue&type=style&index=0&id=3ded9e6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded9e6c",
  null
  
)

export default component.exports